<template>
  <router-view :fluid="fluid"></router-view>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      fluid: null,
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        this.fluid = to.meta.fluid || null
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
